module.exports = __webpack_public_path__ + "media/time@2x-aeb03afa.png";